<template>
  <div class="account-info" :class="[ishow?'account-ishow':'',place]">
    <div class="info-list" @mouseleave="ishow=false">
      <p>账户中心：<a style="cursor: pointer" @click="gopersonal" v-if="isinfo">前往 <em class="right-arrow"></em><em
        class="right-arrow"></em></a></p>
      <p>{{ name }}</p>
      <p v-if="phone">{{ phone }}</p>
      <em class="line"></em>
      <p style="padding-bottom: 0" v-if="isinfo"><span @click="exits()">退出登录</span></p>
      <p style="padding-bottom: 0" v-else><span @click="gotologin()">点击登录</span></p>
    </div>
    <span class="account-state" @mousemove="ishow=true">{{ isinfo ? '已登录' : name }}</span>
    <div class="attention-qrcode" v-if="qrshow"></div>
  </div>
</template>

<script>
import myStorage from '../../bll/utils'

export default {
  name: 'AccountInfo',
  props: {
    place: {
      type: String,
      default: ''
    },
    keepalives: [Boolean, Array, String],
    permissions: [Array, String]
  },
  data () {
    return {
      ishow: false,
      isinfo: false,
      name: '游客',
      phone: '',
      qrshow: false
    }
  },
  created () {
    if (!this.keepalives) {
      this.getuserinfodata(2)
    }
    let gotos=localStorage.getItem('gotourl')
    if(!gotos){
      localStorage.setItem('gotourl', window.location.hash)
    }
  },
  activated () {
    this.getuserinfodata(1)
  },
  methods: {
    getuserinfodata (nums) {
      let ids = this.getUrlParam('code') || this.$route.query.code
      let thirdToken = this.getUrlParam('thirdToken') || this.$route.query.thirdToken
      let appid = this.getUrlParam('appid') || this.$route.query.appid
      let login = this.$route.query.login
      let $this = this
      if (login) {
        this.$alert('您还未登录或登录已失效，不可以访问其他功能！', '系统提示', {
          confirmButtonText: '去登录',
          type: 'warning',
          center: true,
          callback: action => {
            $this.$router.push('/login')
          }
        })
      }

      let hash=window.location.hash
      if(hash.indexOf('f8fb172eeeae0a')>-1){
        appid ='f8fb172eeeae0a'
      }
      // if(thirdToken){
      //   this.$api.post('/api-ca/cockpit/checktoken', {thirdToken:thirdToken}, (response) => {
      //     let datas=response.data||{};
      //     if(datas.code=='000000'){
      //     }
      //   },'json')
      // }
      // let test={"uniscid":"91330109MABM8FXA3B","personCardNo":null,"entName":"浙江萧山化学纤维产业大脑有限公司","phone":"15168318214","userName":"任航斌","userId":152}
      // localStorage.setItem('userinfo',JSON.stringify(test))
      if (ids || thirdToken || appid) {
        // const identification = ids || thirdToken
        this.$api.post('/api-ca/dvolution/getuserinfo', {code: [ids || '', thirdToken || '', appid || '']}, (response) => {
          let datas = response.data || {}
          if (datas.code == '000000') {
            let token = response.headers.token || ''
            let isReload = response.headers.isreload || ''
            if (token) {
              myStorage.setItem('localStorage', 'token', token)
            }
            if (isReload) {
              localStorage.setItem('accountid', datas.data.accountid)
              localStorage.setItem('tokens', token)
            } else {
              localStorage.removeItem('accountid')
              localStorage.removeItem('tokens')
            }
            myStorage.setItem('localStorage', 'userinfo', datas.data)
            this.isinfo = true
            this.name = datas.data.zh
            this.phone = datas.data.sjhm
          }
        }, 'json')
      } else {
        let info = myStorage.getItem('localStorage', 'userinfo') // localStorage.getItem('userinfo')
        if (info) {
          // let infos=JSON.parse(info)
          this.isinfo = true
          this.name = info.zh
          this.phone = info.sjhm
        } else {
          const accountid = localStorage.getItem('accountid')
          if (accountid) {
            const url = '/api-portal/account/accountInformation'
            this.$api.get(url, {accountId: accountid}, (response) => {
              let datas = response.data || ''
              let token = response.headers.token || ''
              let isReload = response.headers.isreload || ''
              let userinfo = datas.data || ''
              if (token) {
                myStorage.setItem('localStorage', 'token', token)
              }
              if (isReload) {
                localStorage.setItem('accountid', userinfo.accountid)
                localStorage.setItem('tokens', token)
              } else {
                localStorage.removeItem('accountid')
                localStorage.removeItem('tokens')
              }
              if (userinfo) {
                myStorage.setItem('localStorage', 'userinfo', userinfo)
                this.isinfo = true
                this.name = userinfo.zh
                this.phone = userinfo.sjhm
              } else {
                this.isinfo = false
                this.name = '游客'
                this.phone = ''
              }
            }, 'json')
          } else {
            this.isinfo = false
            this.name = '游客'
            this.phone = ''
          }
        }
      }
      if (this.phone == '19550238055') {
        this.qrshow = true
      }
      if (this.permissions) {
        const info = myStorage.getItem('localStorage', 'userinfo')
        // console.log(info)
        if (info) {
          // const infoname=info.zhnc
          // if((process.env.ACCESSP).indexOf(infoname)<0){
          //   this.$alert('该功能需要访问权限才能进入，请联系管理员！', '系统提示', {
          //     confirmButtonText: '确定',
          //     type: 'warning',
          //     center: true,
          //     callback: action => {
          //       $this.$router.push('/home')
          //     }
          //   })
          // }
        } else {
          this.gotologin()
        }
      }
    },
    exits () {
      let $this = this
      this.$confirm('确定需要退出吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        let info = myStorage.getItem('localStorage', 'userinfo')
        if (info) {
          const url = '/api-ca/login/logoutportal'
          this.$api.post(url, {loginname: $this.name}, (response) => {
            let datas = response.data || ''
            if (datas.code == '000000') {
              $this.isinfo = false
              $this.name = '游客'
              $this.phone = ''
              localStorage.removeItem('userinfo')
              localStorage.removeItem('token')
              localStorage.removeItem('accountid')
              localStorage.removeItem('tokens')
              $this.$router.replace('/home')
            }
          }, 'json')
        } else {
          $this.isinfo = false
          $this.name = '游客'
          $this.phone = ''
          localStorage.removeItem('userinfo')
          localStorage.removeItem('token')
          localStorage.removeItem('accountid')
          localStorage.removeItem('tokens')
          $this.$router.replace('/home')
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消退出'
        })
      })
    },
    getUrlParam (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return decodeURI(r[2])
      return null
    },
    gopersonal () {
      this.$router.push('/user/personal')
    },
    gotologin () {
      localStorage.setItem('gotourl', window.location.hash)
      this.$router.push('/login')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.account-info {
  position: fixed;
  left: 0px;
  top: -180px;
  /*top: 84px;*/
  width: 180px;
  font-size: 13px;
  z-index: 110;
  height: 180px;
}

.account-state {
  width: 54px;
  height: 29px;
  line-height: 29px;
  text-align: center;
  color: #fff;
  background: #1A4AB8;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  cursor: pointer;
  position: fixed;
  top: 0;
  left: 23px;
  box-shadow: 0 4px 8px 1px rgba(0, 0, 0, .5);
}

.info-rigth {
  left: auto;
  right: 0;
}

.info-rigth .account-state {
  left: auto;
  right: 23px;
}

.info-list {
  padding: 20px 25px;
  width: 130px;
  line-height: 160%;
  color: #fff;
  background: #1A4AB8;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  opacity: 0;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4), 0 6px 20px 0 rgba(0, 0, 0, 0.4);
}

.info-list p {
  padding-bottom: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.info-list .line {
  width: 100%;
  height: 1px;
  display: block;
  border-bottom: 1px solid rgba(255, 255, 255, .6);
  padding-bottom: 2px;
  margin-bottom: 15px;
}

.info-list span {
  cursor: pointer;
}

.account-ishow {
  top: 0px;
  transition: top .5s;
}

.account-ishow .info-list {
  opacity: 1;
  transition: opacity 0.5s;
}

.account-ishow .account-state {
  opacity: 0;
}

.attention-qrcode {
  position: fixed;
  right: 5px;
  top: 5px;
  background: #558CFF url("../../assets/hxzl.png") no-repeat center/90%;
  width: 115px;
  height: 115px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/account-info.vue